import { render } from "./FieldManagerModal.vue?vue&type=template&id=1488d81a&scoped=true"
import script from "./FieldManagerModal.vue?vue&type=script&lang=js"
export * from "./FieldManagerModal.vue?vue&type=script&lang=js"

import "./FieldManagerModal.vue?vue&type=style&index=0&id=1488d81a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1488d81a"]])

export default __exports__